import React from 'react';
import PropTypes from 'prop-types';

import { CustomInput } from 'reactstrap';

import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from '../Search/reducer';
import saga from '../Search/saga';
import { makeSelectSelectedTags } from '../HorizontalFilter/selectors';
import {
  addOption,
  hideTag,
  removeOption,
  showTag,
} from '../HorizontalFilter/actions';

import './styles.scss';

import _ from 'lodash';

class MultiselectWithSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.id = _.uniqueId();
  }

  handleOnClick = (value, label, active) => {
    if (active) {
      this.props.removeOption(value);
      this.props.showTag(value);
    } else {
      this.props.addOption(value, label);
      this.props.hideTag(value);
    }
  };

  handleOnShow = e => {
    this.setState(prevState => ({
      show: !prevState.show,
    }));
  };

  render() {
    const { label, items, selectedTags } = this.props;
    const { show } = this.state;
    const selected = new Set();
    selectedTags.map(item => selected.add(item.value));
    let componentId = `search-filters-multiselect-with-switch-${label}-${this.id}`.replace(/\s+/g, '-').toLowerCase();;

    if (items.length < true) return null;

    return (
      <div className="Multiselect todo-sidebar-section">
        <h4 className="todo-sidebar-section-header" onClick={this.handleOnShow}>
          <label htmlFor={componentId} className='mb-0'>
            {label}
          </label>
          <span className="" style={{ float: 'right' }}>
            {show ? (
              <i className="os-icon os-icon-arrow-up4" />
            ) : (
              <i className="os-icon os-icon-arrow-down3" />
            )}
          </span>
        </h4>
        {show && (
          <div className="todo-sidebar-section-contents" id={componentId}>
            {items.map((item, key) => {
              if (item === undefined) return null;
              const active = selected.has(item.value);

              return (
                <CustomInput
                  key={key}
                  id={`tags-${item.label}`}
                  type="switch"
                  checked={active}
                  name="tags"
                  label={item.label}
                  onChange={() =>
                    this.handleOnClick(item.value, item.label, active)
                  }
                  value="1"
                />
              )
            })}
          </div>
        )}
      </div>
    );
  }
}

MultiselectWithSwitch.defaultProps = {
  unit: '',
};
MultiselectWithSwitch.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

const mapStateToProps = createStructuredSelector({
  selectedTags: makeSelectSelectedTags(),
});
export function mapDispatchToProps(dispatch) {
  return {
    addOption: (value, label) => dispatch(addOption(value, label)),
    removeOption: value => dispatch(removeOption(value)),
    hideTag: value => dispatch(hideTag(value)),
    showTag: value => dispatch(showTag(value)),
  };
}

const withReducer = injectReducer({ key: 'search', reducer });
const withSaga = injectSaga({ key: 'search', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(MultiselectWithSwitch);
